import { render, staticRenderFns } from "./TenantGuidelinesDetailManage.vue?vue&type=template&id=f4ab2efa&scoped=true"
import script from "./TenantGuidelinesDetailManage.vue?vue&type=script&lang=js"
export * from "./TenantGuidelinesDetailManage.vue?vue&type=script&lang=js"
import style0 from "./TenantGuidelinesDetailManage.vue?vue&type=style&index=0&id=f4ab2efa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ab2efa",
  null
  
)

export default component.exports